import { call, put } from 'redux-saga/effects';
import moment from 'moment/moment';
import processError from '../../../utils/processError';
import { loadStatusFailed, loadStatusSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadStatus(action) {
  try {
    const url = `${BACKEND_URL}/api/status?random=${Math.random() * 1000}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadStatusSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadStatusFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadStatusFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
